<script>

    import ModalEdit from '../../../layouts/ModalEdit.vue';
    import ProductService from './ProductService.js';

    export default {
        name: 'modal',
        props: ['value'],
        extends: ModalEdit,
        data: function () {
            return {
              internalValue: '',
              locales: null,
              locale: 'all',
              localesLoaded: true,
              selection: {},
              children: {},
              query: null,
              productService: null,
              results: []
            }
        },
        mounted: function(){
          this.locales = this.$store.state.scope.locales
          this.locale = this.$store.state.scope.locales[0].id
          this.productService = ProductService;

          setTimeout(() => {
            this.$refs.focusMe.focus();
          }, 500);
        },
        created: function() {
          this.internalValue = this.value;

          this.initialize();
        },
        methods: {
            close() {
                this.$emit('close');
            },
            validate(item){
                this.$emit('validate', item)
            },
          async:function(){
            this.productService.all('?query=' + this.query).then(response => {
              if (response) {
                this.results = response.data.data ? response.data.data : response.data
              }
            })
          }
        }
    };
</script>
<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="close()"></div>
            <div class="modal dialog"
                 role="dialog"
                 aria-labelledby="modalTitle"
                 aria-describedby="modalDescription">
                <article>
                    <header
                            class="modal-header"
                            id="modalTitle">
                        <figure><icon name="file-search-02"/></figure>
                        <div>
                            <h1>Rechercher un produit</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="close()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <!--<button @click="validate()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>-->
                        </div>
                    </header>
                    <div class="catalog-search">

                      <div class="catalog-search-input">
                        <input type="text" v-model="query" @keydown="async()" ref="focusMe"/>
                        <icon name="search-sm"/>
                      </div>

                      <div class="catalog-search-results">
                        <div v-for="item in results" class="catalog-search-results-item" @click="validate(item)">

                            <figure>
                              <img :src="item.picture" />
                            </figure>
                            <div class="content">
                              <h3>{{ item.name }}</h3>
                              <p class="sku">{{ item.sku }}</p>
                              <p>{{ item.description }}</p>
                              <p>Quantité en stock: {{ item.stock.quantity }}</p>
                              <p class="price"><span class="currency">{{ $store.state.scope.currency_id }}</span> {{ item.price[$store.state.scope.is_ttc?"ttc":"ht"]|formatNumber }}</p>
                            </div>
                          </div>

                      </div>

                    </div>
                </article>
            </div>
        </div>
    </transition>
</template>


// WEBPACK FOOTER //
// src/modules/shop/product/ModalSearch.vue